import React from 'react';

import classNames from 'classnames';

import styles from './Arrow.module.css';

export enum ArrowColor {
  disabled = 'var(--grey-300)',
  primary = 'var(--midnight-purple)',
}

type ArrowVariant = 'up' | 'down' | 'right' | 'left';

export type Props = {
  className?: string;
  fill?: string;
  height?: number;
  onClick?(): void;
  variant?: ArrowVariant;
  width?: number;
};
export const Arrow = React.memo((props: Props) => {
  return (
    <svg
      width={props.width || 24}
      height={props.height || 24}
      className={classNames(styles.root, styles[props.variant || 'right'], props.className)}
      onClick={props.onClick}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M13.2699 18.6698L20 11.9397L13.1514 5.33026'
        stroke={props.fill || 'white'}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <line
        x1='16.9816'
        y1='12'
        x2='5.98157'
        y2='12'
        stroke={props.fill || 'white'}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
});

Arrow.displayName = 'Arrow';
